import {
  DatePicker,
  Form,
  FormProps,
  Input,
  Modal,
  ModalProps,
} from '@pankod/refine-antd'
import React from 'react'
import 'dayjs/locale/id'
import locale from 'antd/lib/locale/id_ID'
import dayjs from 'dayjs'

import { BatchRequest, BatchResponse, BatchUpdateRequest } from '../types'

type TModalFormProps = {
  modalProps: ModalProps
  formProps: FormProps
  mode: 'create' | 'edit'
  onClose: () => void
}
export const ModalForm = ({
  modalProps,
  formProps,
  mode,
  onClose,
}: TModalFormProps) => {
  return (
    <Modal
      {...modalProps}
      onCancel={onClose}
      title={mode === 'create' ? 'Buat Angkatan Baru' : 'Edit Angkatan'}
      okText="Simpan"
      cancelText="Kembali"
    >
      <Form<BatchRequest | BatchUpdateRequest>
        {...formProps}
        layout="vertical"
        validateMessages={{ required: '${label} harus diisi.' }}
        initialValues={(() => {
          return formProps?.initialValues?.data || {}
        })()}
      >
        <Form.Item
          label="Nama Angkatan"
          name="name"
          required
          rules={[{ required: true }]}
        >
          <Input autoComplete="off" placeholder="Tulis nama angkatan" />
        </Form.Item>
        <Form.Item
          label="Periode Pengelompokan Semester Satu"
          name="firstSemesterCollectionDate"
          getValueProps={(
            dates: BatchResponse['firstSemesterCollectionDate'],
          ) => ({
            value: dates ? [dayjs(dates.startDate), dayjs(dates.endDate)] : [],
          })}
          required
          rules={[
            { required: true },
            {
              validator(_, value: BatchRequest['firstSemesterCollectionDate']) {
                if (
                  value &&
                  !dayjs(value.startDate).isBefore(dayjs(value.endDate), 'day')
                ) {
                  return Promise.reject(
                    'Tanggal mulai periode pengelompokan Semester 1 harus lebih awal dari tanggal selesai.',
                  )
                }
                return Promise.resolve()
              },
            },
          ]}
          getValueFromEvent={(dates) =>
            dates?.[0] && dates?.[1]
              ? {
                  startDate: dates[0].toISOString(),
                  endDate: dates[1].toISOString(),
                }
              : undefined
          }
        >
          <DatePicker.RangePicker
            format="DD MMM YYYY"
            locale={locale.DatePicker}
          />
        </Form.Item>
        <Form.Item
          label="Periode Pengelompokan Semester Dua"
          name="secondSemesterCollectionDate"
          dependencies={['firstSemesterCollectionDate']}
          getValueProps={(
            dates: BatchResponse['secondSemesterCollectionDate'],
          ) => ({
            value: dates ? [dayjs(dates.startDate), dayjs(dates.endDate)] : [],
          })}
          required
          rules={[
            { required: true },
            ({ getFieldValue }) => ({
              validator(
                _,
                value: BatchRequest['secondSemesterCollectionDate'],
              ) {
                if (
                  value &&
                  !dayjs(value.startDate).isBefore(dayjs(value.endDate), 'day')
                ) {
                  return Promise.reject(
                    'Tanggal mulai periode pengelompokan Semester 2 harus lebih awal dari tanggal selesai.',
                  )
                }

                const firstSemesterCollectionDate:
                  | BatchRequest['firstSemesterCollectionDate']
                  | undefined = getFieldValue('firstSemesterCollectionDate')

                if (
                  firstSemesterCollectionDate &&
                  value &&
                  dayjs(value.startDate).isBefore(
                    dayjs(firstSemesterCollectionDate.startDate),
                    'day',
                  )
                ) {
                  return Promise.reject(
                    'Periode pengelompokan semester dua tidak boleh lebih awal dari periode pengelompokan semester satu.',
                  )
                }

                if (
                  firstSemesterCollectionDate &&
                  value &&
                  dayjs(value.endDate).isBefore(
                    dayjs(firstSemesterCollectionDate.endDate),
                    'day',
                  )
                ) {
                  return Promise.reject(
                    'Tanggal selesai periode pengelompokan Semester 2 tidak boleh lebih awal dari Semester 1.',
                  )
                }
                return Promise.resolve()
              },
            }),
          ]}
          getValueFromEvent={(dates) =>
            dates?.[0] && dates?.[1]
              ? {
                  startDate: dates[0].toISOString(),
                  endDate: dates[1].toISOString(),
                }
              : undefined
          }
        >
          <DatePicker.RangePicker
            format="DD MMM YYYY"
            locale={locale.DatePicker}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
